import { createApi } from '@reduxjs/toolkit/query/react';

import { RootState } from '@store/index';

import { TAG_PARTNERS } from '../../config/tags';
import {
  PARTNERS,
  PARTNERS_ISSUE_CERTIFICATE,
} from '../../config/urls';

import { baseQuery } from './baseQuery';

import type { Partner } from '../types/partner/partner';

// Define a service using a base URL and expected endpoints
export const partnersApi = createApi({
  reducerPath: 'partners',
  tagTypes: [TAG_PARTNERS],
  baseQuery,
  refetchOnFocus: true,
  endpoints: (builder) => ({
    getPartners: builder.query<Partner, void>({
      query: () => ({
        url: PARTNERS,
      }),
    }),
    postPartnerCertificate: builder.mutation<Partner, FormData>({
      query: (payload) => ({
        url: PARTNERS_ISSUE_CERTIFICATE,
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: partnersResponseWithExpirationDate } = await queryFulfilled;
          dispatch(
            partnersApi.util.updateQueryData('getPartners', undefined, (draft) => {
              Object.assign(draft, partnersResponseWithExpirationDate);
            })
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      },
    }),
  }),
});

export const getPartners = (state: RootState) =>
  partnersApi.endpoints.getPartners.select()(state).data;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetPartnersQuery,
  usePostPartnerCertificateMutation,
} = partnersApi;
